function PerformanceDashboard() {
    return (
      <div className="p-4">
        <h1 className="text-2xl font-bold mb-4">PerformanceDashboard</h1>

      </div>
    );
  }
  
  export default PerformanceDashboard;